<template>
  <div v-if="loading === false" class="containerMembership">
    <b-container fluid v-if="($mq === 'mobile' || $mq === 'tablet')">
      <!-- header -->
      <HeaderBackMobile :backToHome="false" leftAction="menu"/>
      <main style="position:relative">
        <b-row style="margin-top:30px;">
          <b-col style="text-align:center;">
            <input id="camera" type="file" accept="image/*" capture="camera" class="inputfile" />
            <label for="camera" style="text-decoration:underline; text-align:center;">
              <font-awesome-icon style="cursor:pointer;font-size:28px;margin-right:10px;" :icon="['fas', 'camera']"/>CAPTURAR NOTA FISCAL
            </label>
            <img id="frame" style="max-width:100%;">
          </b-col>
        </b-row>
        <b-row style="margin-top:50px;padding-bottom:140px;">
          <b-col style="font-size:13px;color:#777777;">
            <li> Capture uma imagem da nota fiscal de outro estabelecimento vendedor dos produtos <span style="font-size:14px;" :style="{color: getCssColor('primary_bt')}">{{$store.state.company.companyBrand}}</span>.</li>
            <li> O número e os produtos devem estar legíveis na foto, se necessário dobre o cupom.</li>
            <li> Quando a imagem for processada em nossos servidores, os pontos serão creditados automaticamente em sua carteira de pontos.</li>
          </b-col>
        </b-row>
        <b-row style="height:72px;position:fixed;background-color:#ffffff;z-index:18000;bottom:50px;width:100%">
         <div
            @click="sendPicture()"
            :style="{backgroundColor: getCssColor('primary_bt')}"
            style="
            margin:12px auto;
              width:calc( 100% - 30px);
              height:48px;
              line-height:48px;
              border-radius:4px;
              text-align:center;
              font-style: normal;
              font-weight: 600;
              font-size: 15px;
              text-transform: uppercase;
              color: #FFFFFF;">ENVIAR FOTO DA NOTA FISCAL</div>
        </b-row>
        <b-row >
          <b-col>
            
          </b-col>
        </b-row>
      </main>
      <footer style="position:relative;">
        <!-- fixed down menu -->
        <MembershipNavigation selected="scan"/>
      </footer>
    </b-container>
  </div>
  <div v-else>
    <InnerLoading/>
  </div>
</template>

<script>
import InnerLoading from '@/components/InnerLoading'
import MembershipNavigation from '@/components/MembershipNavigation'
import HeaderBackMobile from '@/components/HeaderBackMobile.vue'
import colors from '@/mixins/colors'
import Images from '@/connection/images'
import { EventBus } from '@/behaviours/event-bus'

export default {
  data () {
    return {
      loading: false,
      typing: false,
      imageFile: null,
      camera: null,
      frame: null
    }
  },
  mixins: [colors],
  components: {InnerLoading, HeaderBackMobile, MembershipNavigation },

  mounted () {
    let vm = this
    vm.camera = document.getElementById('camera')
    vm.frame = document.getElementById('frame')

    vm.camera.addEventListener('change', function(e) {
      let file = e.target.files[0]
      vm.frame.src = URL.createObjectURL(file)
      vm.imageFile = e.target.files[0]
    })
  },

  methods: {
    
    async sendPicture () {
      if (!this.imageFile) {
        EventBus.$emit('showAlert', 'warning', 'Capture a foto da nota fiscal antes.')
      } else {
        this.$store.state.showLoading = true
        let result = await Images.saveInvoiceImage(this.imageFile)
        this.$store.state.showLoading = false
        if (!result.error) {
          this.frame.src = null
        }
        EventBus.$emit('showAlert', 'error', result.msg)
      }
    }
  }
}
</script>

<style scoped>
.inputfile {
  /* visibility: hidden etc. wont work */
  width: 0.1px;
  height: 0.1px;
  opacity: 0;
  overflow: hidden;
  position: absolute;
  z-index: -1;
}
.inputfile:focus + label {
  /* keyboard navigation */
  outline: 1px dotted #000;
  outline: -webkit-focus-ring-color auto 5px;
}
.inputfile + label * {
  pointer-events: none;
}
</style>
